function supportsUserSelectContain() {
  const el = document.createElement('div')
  el.style.cssText = 'user-select: contain;'
  return el.style.getPropertyValue('user-select') === 'contain'
}
function handleUserSelectContain(event: Event) {
  if (!(event.target instanceof Element)) return
  const currentTarget = event.target.closest('.user-select-contain')
  if (!currentTarget) return

  const selection = window.getSelection()
  if (!selection) return
  if (!selection.rangeCount) return
  if (!selection.rangeCount || selection.type !== 'Range') return

  const container = selection.getRangeAt(0).commonAncestorContainer
  if (currentTarget.contains(container)) return
  selection.selectAllChildren(currentTarget)
}

export function installUserSelectContainPolyfill(
  supportsContain = supportsUserSelectContain,
  addClickListener = () => document.addEventListener('click', handleUserSelectContain),
) {
  if (!supportsContain()) {
    addClickListener()
  }
}

installUserSelectContainPolyfill()

export {}
